import React from 'react';

interface AIInviteOnlyIconProps {
  color?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const AIInviteOnlyIcon: React.FC<AIInviteOnlyIconProps> = ({
  color = '#2372b9',
  height = 36,
  width = 36,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 36 36"
    fill="none"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
  >
    <path
      d="M19.63 10.9969C20.5162 10.575 21.1305 9.67031 21.1305 8.625C21.1305 7.17656 19.9536 6 18.5047 6C17.0558 6 15.8789 7.17656 15.8789 8.625C15.8789 9.67031 16.4931 10.575 17.3793 10.9969V15.6281C17.248 15.6891 17.1214 15.7641 17.0042 15.8484L13.2484 13.7016C13.3234 12.7266 12.8451 11.7516 11.9402 11.2266C10.6835 10.5 9.0799 10.9313 8.35311 12.1875C7.62632 13.4437 8.05771 15.0469 9.31435 15.7734C9.3753 15.8109 9.43626 15.8438 9.5019 15.8719V20.1281C9.44095 20.1562 9.3753 20.1891 9.31435 20.2266C8.05771 20.9531 7.62632 22.5562 8.35311 23.8125C9.0799 25.0688 10.6835 25.5 11.9402 24.7734C12.8451 24.2531 13.3187 23.2734 13.2437 22.2984L15.6116 20.9437C15.0724 20.4187 14.6785 19.7438 14.4956 18.9891L12.1277 20.3484C12.0058 20.2641 11.8839 20.1937 11.7526 20.1281V15.8719C11.8839 15.8109 12.0105 15.7359 12.1277 15.6516L15.8836 17.7984C15.8789 17.8641 15.8742 17.9297 15.8742 18C15.8742 19.0453 16.4884 19.95 17.3747 20.3719V25.0031C16.4884 25.425 15.8742 26.3297 15.8742 27.375C15.8742 28.8234 17.0511 30 18.5 30C19.9489 30 21.1258 28.8234 21.1258 27.375C21.1258 26.3297 20.5116 25.425 19.6253 25.0031V20.3719C19.7566 20.3109 19.8832 20.2359 20.0005 20.1516L23.7563 22.2984C23.6813 23.2734 24.1596 24.2484 25.0598 24.7734C26.3165 25.5 27.9201 25.0688 28.6469 23.8125C29.3737 22.5562 28.9423 20.9531 27.6857 20.2266C27.6247 20.1891 27.5591 20.1563 27.4981 20.1281V15.8719C27.5637 15.8438 27.6247 15.8109 27.6857 15.7734C28.9423 15.0469 29.3737 13.4437 28.6469 12.1875C27.9201 10.9313 26.3259 10.5 25.0692 11.2266C24.1643 11.7469 23.6907 12.7266 23.7657 13.7016L21.3931 15.0563C21.9323 15.5813 22.3262 16.2562 22.5091 17.0109L24.8817 15.6516C25.0036 15.7359 25.1255 15.8063 25.2568 15.8719V20.1281C25.1255 20.1891 24.9989 20.2641 24.8817 20.3438L21.1258 18.1969C21.1305 18.1313 21.1352 18.0656 21.1352 17.9953C21.1352 16.95 20.5209 16.0453 19.6347 15.6234V10.9922L19.63 10.9969Z"
      fill={color}
    />
  </svg>
);

export default AIInviteOnlyIcon;